import '../App.css';
import 'animate.css';
import { Link } from 'react-router-dom';
import evently from '../assets/images/project-evently.jpg';
import rettich from '../assets/images/project-rettichproductons.jpg';
import covid from '../assets/images/project-symptomchecker.jpg';
import '../index.css';

function Home() {
  return (
    <div className="App">
      <div className="home-container">
      <h1 className="scroll-down-arrow animate__animated animate__fadeInDown animate__slow animate__delay-1s">↓</h1>

        <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">a.mcknight<span className="grey">.digital</span></h5>
        <h1 className="element">👋</h1>
        <h1 className="animate__animated animate__fadeInUp animate__slow">Hello, I'm Adam! <br/> I build Software and Security solutions.</h1>
        <div className="about animate__animated animate__fadeInUp animate__slower animate__delay-1s">
          <h3>
            I'm actively looking for Internships, click <Link to="/resume">here</Link> to view and download my Resume.
          </h3>
          <h3>
            I specialize in building Software Applications for both web and enterprise. Most projects are built using React, and .NET. Other applications have been built using C++ and Python. View my <a href="https://www.github.com/apmcknight">github</a> to learn more.
          </h3>
        </div>
        <div className="projects">
            <h1>— recent projects</h1>
          
          <Link className="projectTemplate" to="/evently">
            <div style={{marginTop: "80px", marginBottom: "80px"}} className="projectOne">
              <h1>1 | ev•ent•ly</h1>
              <img className="projectImage" src={evently} alt="Evently" />
              <h3>
                Evently is an Full Stack App for Theater and Concert Venues, built in DOT.NET click <Link to="/evently">anywhere</Link> to learn more.
              </h3>
            </div>
          </Link>

          <Link className="projectTemplate" to="/rettich-productions">
            <div style={{marginTop: "80px", marginBottom: "80px"}} className="projectOne">
              <h1>2 | Rettich Productions</h1>
              <img className="projectImage" src={rettich} alt="Evently" />
              <h3>
                Rettich Productions is an Live A/V/L Consulting company providing equipment rentals, calibration services and more. We re-designed their site in late 2020! Click <a href="/rettich-productions">here</a> to learn more.
              </h3>
            </div>
          </Link>  

          <Link className="projectTemplate" to="/covid-kiosk">
            <div style={{marginTop: "80px", marginBottom: "80px"}} className="projectOne">
              <h1>3 | COVID Kiosk</h1>
              <img className="projectImage" src={covid} alt="Evently" />
              <h3>
                COVID Kiosk was a project built during "lock-downs" it asks the user a series of questions and then determines if they may have or have had COVID. Note, this is not meant to be a replacement for a test and medical advise should be given by trained professionals. To learn more click <a href="/resume">here</a>.
              </h3>
            </div>
          </Link>
            
          </div>
       
        <h5 className="grey home-link">
          <a href="legal">view privacy and site license —</a>
          {/* Make a link */}
        </h5>
      </div>

      
      
    </div>
  );
}

export default Home;
